import EVENTS from "../lib/events.js"

const { SWIPE_NAV_PREV, SWIPE_NAV_NEXT } = EVENTS

export default class SwipeNav {
  constructor(source) {
    this.source = source
    this.prevEvent = new Event(SWIPE_NAV_PREV)
    this.nextEvent = new Event(SWIPE_NAV_NEXT)
  }

  init(swipeableElement) {
    this.controller = new AbortController()
    this.eventOptions = { signal: this.controller.signal }

    swipeableElement.addEventListener(
      "pointerdown",
      this._handleSwipeStart.bind(this),
      this.eventOptions,
    )
    swipeableElement.addEventListener(
      "pointerup",
      this._handleSwipeEnd.bind(this),
      this.eventOptions,
    )
  }

  _handleSwipeStart(event) {
    this.swipeStartX = event.offsetX
    this.swipeStartY = event.offsetY
  }

  _handleSwipeEnd(event) {
    this.swipeEndX = event.offsetX
    this.swipeEndY = event.offsetY

    // For a swipe to register, it can only deviate on the y-axis by 20px, and must be 15px, or more, on the x-axis
    if (
      Math.abs(this.swipeStartY - this.swipeEndY) <= 20 &&
      Math.abs(this.swipeStartX - this.swipeEndX) >= 15
    ) {
      if (this.swipeStartX > this.swipeEndX) {
        this.source.dispatchEvent(this.nextEvent)
      } else if (this.swipeStartX < this.swipeEndX) {
        this.source.dispatchEvent(this.prevEvent)
      }
    }
  }

  destroy() {
    this.controller?.abort()
  }
}
